export const FAQ_PAGE_SLUG = "faq";
